import { ESubscriptionProductType } from "common/enums/ProductSubscribed/ESubscriptionProductType";
import I18n from "components/materials/I18n";
import classes from "./classes.module.scss";

type IProps = {
	isDemembrementType: boolean;
	productSelected: boolean;
	contrepartieChoice: "avec" | "sans" | null;
	subscriptionProductTypeSelected: ESubscriptionProductType;
};

export default function DemembrementWarnings({ isDemembrementType, productSelected, contrepartieChoice, subscriptionProductTypeSelected }: IProps) {
	if (!isDemembrementType || !productSelected) return null;

	return (
		<>
			{subscriptionProductTypeSelected === ESubscriptionProductType.usufruit && contrepartieChoice === "sans" && (
				<div className={classes["usufruit-warning"]}>
					{I18n.asset.pages.subscriptions.select_products.usufruit_warning.message}
					<a href={`mailto:${I18n.asset.pages.subscriptions.select_products.usufruit_warning.email}`}>
						{I18n.asset.pages.subscriptions.select_products.usufruit_warning.email}
					</a>
				</div>
			)}
			{contrepartieChoice === "avec" && (
				<div className={classes["with-contrepartie-warning"]}>{I18n.asset.pages.subscriptions.select_products.with_contrepartie_warning}</div>
			)}
		</>
	);
}
